import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { getCurrentDate, getPastDate } from "../utils/formatTime";
import { getStoredValue } from "../_helpers/storagehelper";
import { transformMessages } from "../_helpers/transformMessages";

const loggedUser = getStoredValue("user")?.ManagementUserID;

const initialMessagesData = {
  MessageID: 0,

  error: null,
  loading: false,
  createdBy: loggedUser,
};

const messageSearch = {
  FacilityID: 0,
  InmateResidentId: "",
  ManagementUserID: 1,
  PublicUserID: 0,
  PublicFirstName: "",
  PublicLastName: "",
  InmateFirstName: "",
  InmateLastName: "",
  MessageSubject: "",
  InmateStatus: 1,
  MessageDirection: 0,
  MessageSendStartDate: getPastDate(1),
  MessageSendEndDate: getCurrentDate(1),
  MessageFlag: 3,
  MessageStatus: "0",
  PageNo: 1,
  RowCountPerPage: 10,
  SortBy: "MessageID DESC",
};
// create slice
const name = "messages";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const messagesAction = { ...slice.actions, ...extraActions };
export const messagesReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    messageSearchData: messageSearch,
    messageSearch,
    messagesData: initialMessagesData,
    messagesList: {},
    messagesIDSList: {},
    messageConversationDetails: {},
    submitReview: {},
    viewCompleteConversation: [],
    handleApproveRejectResponse: {},
  };
}

function createReducers() {
  return {
    setMessagesData,
    resetForm,
    resetReviewResponse,
    resetApproveRejectResponse,
    updateCompleteConvo,
    setMessageSearchData,
    resetMessageSearchData,
    updateMessageConversationDetails,
    setmessagesList
  };

  function resetForm(state) {
    state.messagesData = initialMessagesData;
  }

  function resetReviewResponse(state) {
    state.submitReview = {};
  }

  function resetApproveRejectResponse(state) {
    state.handleApproveRejectResponse = {};
  }
  function setMessageSearchData(state, action) {
    state.messageSearchData = action.payload;
  }

  function resetMessageSearchData(state) {
    state.messageSearchData = { ...messageSearch };
  }

  function setMessagesData(state, action) {
    state.messagesData = action.payload && action.payload;
  }

  function updateCompleteConvo(state, action) {
    state.viewCompleteConversation = action.payload && action.payload;
  }

  function setmessagesList(state, action) {
    state.messagesList = action.payload && action.payload;
  }

  function updateMessageConversationDetails(state, action) {
    state.messageConversationDetails = action.payload && action.payload;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser`;
  return {
    getMessagesList: getMessagesList(),
    GetLoadMessageIDList: GetLoadMessageIDList(),
    getExportMessagesList: getExportMessagesList(),
    getMessageConversationDetails: getMessageConversationDetails(),
    submitReview: submitReview(),
    viewCompleteConversation: viewCompleteConversation(),
    handleApproveReject: handleApproveReject(),
  };

  function GetLoadMessageIDList() {
    return createAsyncThunk(
      `${name}/GetLoadMessageIDList`,
      async (messagesData) =>
        await fetchWrapper.post(
          `${baseUrl}/Message/GetLoadMessageIDList`,
          messagesData
        )
    );
  }

  function getMessagesList() {
    return createAsyncThunk(
      `${name}/getMessages`,
      async (messagesData) =>
        await fetchWrapper.post(
          `${baseUrl}/Message/LoadMessageList`,
          messagesData
        )
    );
  }

  function getExportMessagesList() {
    return createAsyncThunk(
      `${name}/getExportMessagesList`,
      async (messagesData) =>
        await fetchWrapper.post(
          `${baseUrl}/Message/LoadExportMessageList`,
          messagesData
        )
    );
  }

  function getMessageConversationDetails() {
    return createAsyncThunk(
      `${name}/messageConversation`,
      async (data) =>
        await fetchWrapper.get(
          `${baseUrl}/Message/GetIDBasedMessages?MessageID=${data?.messageID}&sortBy=${data?.sortBy}&pageNo=${data?.pageNo}&rowCountPerPage=${data?.rowCountPerPage}`
        )
    );
  }
  //submit review
  function submitReview() {
    return createAsyncThunk(
      `${name}/submitReview`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/Message/InmateMessageReviewSave?messageID=${data?.messageID}&userID=${data?.userID || loggedUser}&command=${data?.command}`
        )
    );
  }

  //view complete conversation
  function viewCompleteConversation() {
    return createAsyncThunk(
      `${name}/viewCompleteConversation`,
      async (messageID) =>
        await fetchWrapper.get(
          `${baseUrl}/Message/GetMessageHistoryDetails?messageID=${messageID}&resultType=Display&pageNo=1&rowCountPerPage=10000`
        )
    );
  }

  function handleApproveReject() {
    return createAsyncThunk(
      `${name}/approveReject`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/Message/QuarantineMessageApproveOrReject`,
          data
        )
    );
  }
}

function createExtraReducers(builder) {
  builder
    //get message list
    .addCase(extraActions.getMessagesList.pending, (state, action) => {
      const params = action.meta.arg;
      // Signal_R purpose
      if (!params?.isNoLoading) {
        state.loading = true;
      }
      state.error = null;
    })
    .addCase(extraActions.getMessagesList.fulfilled, (state, action) => {
      state.loading = false;
      const data = action?.payload || [];
      state.messagesList = transformMessages(data);
      state.error = null;
    })
    .addCase(extraActions.getMessagesList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get messages";
    })

    .addCase(extraActions.GetLoadMessageIDList.pending, (state, action) => {
      const params = action.meta.arg;
      // Signal_R purpose
      if (!params?.isNoLoading) {
        state.loading = true;
      }
      state.error = null;
    })
    .addCase(extraActions.GetLoadMessageIDList.fulfilled, (state, action) => {
      state.loading = false;
      state.messagesIDSList = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.GetLoadMessageIDList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get messages";
    })

    //message conversation
    .addCase(extraActions.getMessageConversationDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.getMessageConversationDetails.fulfilled,
      (state, action) => {
        state.loading = false;
        state.messageConversationDetails = action?.payload;
        state.viewCompleteConversation = action?.payload?.DataList || [];
        state.error = null;
      }
    )
    .addCase(
      extraActions.getMessageConversationDetails.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to get messages";
      }
    )

    //notes review
    .addCase(extraActions.submitReview.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.submitReview.fulfilled, (state, action) => {
      state.loading = false;
      state.submitReview = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.submitReview.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to submit review";
    })

    //view complete conversation
    .addCase(extraActions.viewCompleteConversation.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.viewCompleteConversation.fulfilled,
      (state, action) => {
        state.loading = false;
        state.viewCompleteConversation = action?.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.viewCompleteConversation.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to submit review";
      }
    )

    //handle Approve Reject
    .addCase(extraActions.handleApproveReject.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.handleApproveReject.fulfilled, (state, action) => {
      state.loading = false;
      state.handleApproveRejectResponse = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.handleApproveReject.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to Apprve or reject";
    });
}
